// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1604) return "static/chunks/1604-6f08caa2def6e714.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8550 ? "ed48eaa7" : chunkId) + "." + {"197":"50b06ddeb970cf2a","4165":"0b6f9862ca0b84b3","4468":"956bea5e90252d3f","4935":"06766964a296418e","7355":"ba67535f4a7a7568","7696":"4854fea91c000a3e","8550":"2af581c47cedada8","9151":"3e0f816019c88246","9399":"fb67877a66340f7d"}[chunkId] + ".js";
};